import React from 'react';
import { CProgress } from '@coreui/react';

const MoodWidget = ({ mood }) => (
  <div>
    <div className="mb-2">Mood</div>
    <strong>{mood} scale of happiness (80%)</strong>
    <CProgress className="CProgress-xs mt-2" color="danger" value={80} />
  </div>
);

export default MoodWidget;


